<template>
  <div class="loginall">
    <banner-top :text="titletext"></banner-top>
    <div class="loginFuc">
        <div :class="isPhoneReset?'active':''" @click="phoneReset()">手机重置</div>
        <div :class="!isPhoneReset?'active':''" @click="emailReset()">邮箱重置</div>
    </div>
    <el-form
      v-if="isPhoneReset"
      :model="phoneResetForm"
      :rules="rulesPhone"
      key="phoneResetForm"
      ref="phoneResetForm"
    >
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="phone"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon2.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="phoneResetForm.phone"
                placeholder="请输入手机号码"
                maxlength="11"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="code"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon4.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='13'>
              <el-input
                v-model="phoneResetForm.code"
                placeholder="请输入验证码"
                maxlength="6"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                clearable
              ></el-input>
            </el-col>
            <el-col class="inputpass" :span='6'>
                <el-link @click="onCode" style="color:#ffb949; margin-bottom:5px">{{codeText1}}</el-link>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="password"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon3.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="phoneResetForm.password"
                type="password"
                placeholder="请输入新密码"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="again"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon3.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="phoneResetForm.again"
                type="password"
                placeholder="请再次输入新密码"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset('phoneResetForm')">重置密码</el-button>
        </el-form-item>
    </el-form>
    <el-form
      v-else
      :model="emailResetForm"
      :rules="rulesEmail"
      key="emailResetForm"
      ref="emailResetForm"
    >
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="email"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon5.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="emailResetForm.email"
                placeholder="请输入邮箱"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="codeEmail"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon4.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='13'>
              <el-input
                v-model="emailResetForm.codeEmail"
                placeholder="请输入验证码"
                maxlength="6"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                clearable
              ></el-input>
            </el-col>
            <el-col class="inputpass" :span='6'>
                <el-link @click="onCode" style="color:#ffb949; margin-bottom:5px">{{codeText2}}</el-link>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="passwordEmail"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon3.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="emailResetForm.passwordEmail"
                type="password"
                placeholder="请输入新密码"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="againEmail"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon3.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="emailResetForm.againEmail"
                type="password"
                placeholder="请再次输入新密码"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset('emailResetForm')">重置密码</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'rePassword',
  components: { bannerTop },
  data () {
    return {
      isPhoneReset: true,
      titletext: '重置密码',
      codeText1: '获取验证码',
      codeText2: '获取验证码',
      myTime1: null,
      myTime2: null,
      phoneResetForm: {
        phone: '',
        code: '',
        password: '',
        again: ''
      },
      emailResetForm: {
        email: '',
        codeEmail: '',
        passwordEmail: '',
        againEmail: ''
      },
      rulesPhone: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { len: 11, message: '请输入11位手机号码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '请输入6位数字验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码至少输入6位', trigger: 'blur' }
        ],
        again: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { min: 6, message: '密码至少输入6位', trigger: 'blur' }
        ]
      },
      rulesEmail: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        codeEmail: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '请输入6位数字验证码', trigger: 'blur' }
        ],
        passwordEmail: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码至少输入6位', trigger: 'blur' }
        ],
        againEmail: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { min: 6, message: '密码至少输入6位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    reset (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return
        }
        this.doReset()
      })
    },
    doReset () {
      if (this.isPhoneReset) {
        if (this.phoneResetForm.password !== this.phoneResetForm.again) {
          this.$message.error('两次密码输入不一致')
          return
        }
        // 电话号码重置密码
        http['post']('auth/reset/phone', {
          phone: this.phoneResetForm.phone,
          code: this.phoneResetForm.code,
          password: this.phoneResetForm.password
        }).then(() => {
          this.$message.success('重置密码成功!')
          this.$router.push({name: 'login'})
        }).catch((err) => {
          this.$message.error(err)
        })
      } else {
        if (this.emailResetForm.passwordEmail !== this.emailResetForm.againEmail) {
          this.$message.error('两次密码输入不一致')
          return
        }
        // 邮箱注册重置密码
        http['post']('auth/reset/email', {
          email: this.emailResetForm.email,
          code: this.emailResetForm.codeEmail,
          password: this.emailResetForm.passwordEmail
        }).then(() => {
          this.$message.success('重置密码成功!')
          this.$router.push({name: 'login'})
        }).catch((err) => {
          this.$message.error(err)
        })
      }
    },
    async onCode () {
      if (this.isPhoneReset) {
        // 对phone进行判断
        this.$refs['phoneResetForm'].validateField('phone', (errorMessage) => {
          if (errorMessage) {
            return
          }
          const data = {
            phone: this.phoneResetForm.phone,
            type: 'reset'
          }
          http['post']('auth/request_code/phone', data).then(async () => {
            await this.setTime(60 * 1000)
          }).catch((err) => {
            this.$message.error(err)
          })
        })
      } else {
        // 对email进行判断
        this.$refs['emailResetForm'].validateField('email', (errorMessage) => {
          if (errorMessage) {
            return
          }
          const data = {
            email: this.emailResetForm.email,
            type: 'reset'
          }
          http['post']('auth/request_code/email', data).then(async () => {
            await this.setTime(60 * 1000)
          }).catch((err) => {
            this.$message.error(err)
          })
        })
      }
    },
    setTime (time) {
      return new Promise((resolve, reject) => {
        if (this.isPhoneReset) {
          if (this.myTime1) return
          this.codeText1 = time / 1000 + '秒'
          this.myTime1 = setInterval(() => {
            time = time - 1000
            this.codeText1 = time / 1000 + '秒'
            if (time < 0) {
              clearInterval(this.myTime1)
              this.myTime1 = null
              this.codeText1 = '获取验证码'
              resolve()
            }
          }, 1000)
        } else {
          if (this.myTime2) return
          this.codeText2 = time / 1000 + '秒'
          this.myTime2 = setInterval(() => {
            time = time - 1000
            this.codeText2 = time / 1000 + '秒'
            if (time < 0) {
              clearInterval(this.myTime2)
              this.myTime2 = null
              this.codeText2 = '获取验证码'
              resolve()
            }
          }, 1000)
        }
      })
    },
    phoneReset () {
      this.$refs.emailResetForm.clearValidate()
      this.isPhoneReset = true
    },
    emailReset () {
      this.$refs.phoneResetForm.clearValidate()
      this.isPhoneReset = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loginall {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.loginFuc {
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
}
.loginFuc div {
    padding: 1rem 2.4rem;
    font-family: "PingFang-SC-Medium";
    font-size: 18px;
    color: #666;
}
.active {
    color: #ffb949!important;
    border-bottom: 2px solid #ffb949;
}
.loginPassword {
    display: flex;
    justify-content: center;
    width: 70%;
    border-bottom: 1px solid #e6e6e6;
}
.inputpass>>>.el-input__inner {
  border: 0;
}
.iconimg {
    width: 30px;
    height: 30px;
    margin-left: 10px;
}
.loginall button {
    width: 18rem;
    height: 3.5rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    margin-bottom: 1rem;
    color: #fff;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/login/rePassword.vue